<div class="loader">
  <ion-spinner></ion-spinner>
</div>
